import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

export interface LogIntegracaoDialogItem {
  id: number;
  data?: string;
  dataHoraInclusao?: string;
  idLoteScanntech?: string;
  identificador?: string;
  codigo?: string;
  status?: string;
  mensagem?: string;
  url?: string;
}

export interface LogsIntegracaoDialogData {
  titulo: string;
  subtitulo?: string;
  logs: LogIntegracaoDialogItem[];
}

@Component({
  selector: 'app-logs-integracao-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule, MatIconModule, MatTooltipModule],
  templateUrl: './logs-integracao-dialog.component.html',
  styleUrl: './logs-integracao-dialog.component.css',
})
export class LogsIntegracaoDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: LogsIntegracaoDialogData,
    private dialogRef: MatDialogRef<LogsIntegracaoDialogComponent>
  ) {}

  public fechar(): void {
    this.dialogRef.close();
  }
}
